<template>
    <div id="winList">
        <my-header></my-header>
        <img style="margin-top: 70px;" src="../../assets/images/masterCenter/topBg.jpg" alt="" class="banner-image">
        <div class="main-container mainCon">
            <!-- <p class="location">您当前的位置：中标公告</p> -->
            <el-form class="win-form" label-width="140px" ref="form" :model="form">
                <el-row>
                    <!-- <el-col :span="7">
                        <el-form-item label="中标类别：" >
                            <el-select size="medium" v-model="form.categoryId">
                                <el-option label="全部" value=""></el-option>
                                <el-option v-for="t in types" :key="t.id" :label="t.categoryName" :value="t.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col> -->
                    <el-col :span="10">
                        <el-form-item label="中标公告：" >
                            <el-input size="medium" v-model="form.msgTitle" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="3" :offset="1">
                        <el-button class="btn-theme" size="medium"  icon="el-icon-search" @click="searchMethod">搜索</el-button>
                    </el-col>
                </el-row>
            </el-form>
            <ul class="listContent" v-if="winListData.length">
                <li v-for="(item,index) in winListData" :key="index">
                    <div class="leftIndex">
                        <img :src='"../../assets/images/inviteList/0"+(index+1)+".png"' />
                    </div>
                    <div class="rightText">
                        <h3 >
                            <el-tooltip :content="item.msgTitle" :disabled="item.msgTitle.length<30" effect="light">
                                <strong>{{ item.msgTitle }}</strong>
                            </el-tooltip>
                            <span>发布日期：{{ item.createDate }}</span>
                        </h3>
                        <p >
                            <!--<i class="el-icon-document"></i>-->
                            <span><strong>中标单位：</strong>{{ item.msgContent || '无' }}</span>
                        </p>
                        <p class="categray">
                            <span> <strong>中标类别：</strong>{{ item.categoryName || '无' }}</span>
                        </p>
                    </div>
                </li>
            </ul>
            <p v-else class="noResults">没有搜索结果</p>
            <!--   prev-text="上一页"
               next-text="下一页"-->
            <el-pagination
                :page-size="pager.pageSize"
                @current-change="handleCurrentChange"
                :current-page="pager.pageNum"
                :total="pager.total"
                layout="total, prev, pager, next"
                background
            >
            </el-pagination>
        </div>
        <!-- <my-footer></my-footer> -->
    </div>
</template>
<script type="text/babel">
    import MyHeader from '../common/Header.vue'
    import MyFooter from '../common/Footer.vue'
    export default {
        name: 'win-list',
        data(){
            return {
                form: {
                    categoryId: '',
                    msgTitle: ''
                },
                pager:{
                    total: 0,
                    pageNum: 1,
                    pageSize: 8
                },
                types:[],
                winListData:[],//中标公告列表
            }
        },
        components: {
            MyHeader,
            MyFooter
        },
        created(){
            this.$root.activeIndex = 'win';
            this.getCurrentList(1);//获取初始化第一页数据；
            var _this = this;
            _this.$root.postHttp('v1/sSuppliersCategory/public/findSuppliersCategoryTreeList',{//获取招标类别
                "pageNumber": 1,
                "pageSize": 0
            },function(res){
//               console.log('分类',res)
                _this.types = res.data.data.tree;
            });
        },
        methods:{
            getCurrentList(type){//获取当前页面列表数据；
                let _this = this;
                let obj = {};
                if(type == 1){
                    obj = {
                        "pageFlag": 1,//1分页，0不分页
                        "pageNumber": _this.pager.pageNum,
                        "pageSize": _this.pager.pageSize,
                        "resultType": 5 //4 招标公告，5 中标公告
                    };
                } else if(type == 2) {
                    obj = {
                        "categoryId": this.form.categoryId,
                        "msgTitle": this.form.msgTitle,
                        "pageFlag": 1,//1分页，0不分页
                        "pageNumber": _this.pager.pageNum,
                        "pageSize": _this.pager.pageSize,
                        "resultType": 5 //4 招标公告，5 中标公告
                    };
                }
                this.$root.postHttp('/v1/login/public/bidList',obj,function (res) {
//                console.log('列表',res)
                    _this.pager.total = res.data.data.count;
                    _this.winListData = res.data.data.list || [];
                })
            },
            handleCurrentChange (page) {
                this.pager.pageNum = page;
                this.getCurrentList(1);//获取当前页数据；
            },
            searchMethod(){//搜索列表
                this.getCurrentList(2);
            }
        }
    }
</script>
<style lang="scss">
    @import '../../assets/_var.scss';
    #winList {
        & .head-top{
            background: #fff;
        }
        & .head-right {
            color: $--text-color-light;
            & .login {
                background: url('../../assets/images/topBar2/icon07.png') no-repeat 0 1px;
            }
            & .register {
                background: url('../../assets/images/topBar2/icon08.png') no-repeat 0 1px;
            }
            & .line {
                background: $--text-color-light;
            }
            & .help {
                background: url('../../assets/images/topBar2/icon05.png') no-repeat;
            }
            & .wechat {
                background: url('../../assets/images/topBar2/icon06.png') no-repeat;
            }
        }
        & .mainCon {
            margin-top: 15px;
            margin-bottom: 165px;
        }
        .location {
            padding-left: 15px;
            text-align: left;
            font-size: 12px;
            line-height: 42px;
            color: $--text-color-light;
            background: url('../../assets/images/inviteList/location.png') no-repeat left center;
        }
        .win-form {
            background: $--primary-fill-color;
            .el-row {
                padding: 30px 0;
            }
            .el-form-item {
                margin: 0;
            }
            .btn-theme {
                background: $--primary-color;
            }
            .el-button:hover, .el-button:focus {
                background: #fae7eb;
            }
        }
        .listContent {
            margin-top: 30px;
            li {
                overflow: hidden;
                padding: 20px 0;
                border-bottom: 1px solid $--secondary-fill-color;
                .leftIndex {
                    float: left;
                    background-color: $--secondary-fill-color;
                    line-height: 80px;
                    text-align: center;
                    width: 80px;
                    color: $--primary-color;
                    img {
                        vertical-align: middle;
                    }
                }
                .rightText {
                    float: left;
                    width: 1090px;
                    margin-left: 30px;
                    h3 {
                        overflow: hidden;
                        line-height: 40px;
                        strong {
                            float: left;
                            max-width: 500px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            font-size: 16px;
                            color: $--text-color;
                        }
                        strong:hover {
                        }
                        span {
                            float: right;
                            font-size: 14px;
                            font-weight: normal;
                            color: $--text-color-lighter;
                        }
                    }
                    p {
                        padding-left: 10px;
                        text-align: left;
                        color: $--text-color-lighter;
                        font-size: 14px;
                        line-height: 50px;
                        span {
                            color: $--text-color-light;
                        }
                    }
                  /*  .winUnit i {
                        width: 22px;
                        padding-top: 2px;
                        color: $--text-color-light;
                        font-size: 18px;
                    }*/
                    .categray {
                        padding-left: 32px;
                        background: url('../../assets/images/inviteList/icon01.png') no-repeat 10px 17px;
                    }
                }
            }
        }
        .noResults {
            font-size: 16px;
            color: #999;
            margin: 50px;
        }
        .el-pagination {
            margin: 50px 0 70px;
            text-align: right;
        }
    }

</style>



// WEBPACK FOOTER //
// src/pages/win/List.vue